import { Footer } from "@customerexperience/foundation";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Box from "@mui/material/Box";
import { useTranslation } from "next-i18next";

export function AppFooter() {
  const { t } = useTranslation("common");

  return (
    <>
      <Box sx={{ pt: 4 }} data-footer>
        <ThriveDecoration />
        <Footer>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 4, pb: 4 }}>
            <Box sx={{ pl: { xs: 0, sm: "2rem" } }}>
              <Box
                component="ul"
                sx={{
                  listStyle: "none",
                  display: "flex",
                  padding: 0,
                  margin: 0,
                  gap: 4,
                }}
              >
                <li>
                  <a
                    title="Twitter"
                    rel="noopener noreferrer"
                    href="https://www.twitter.com/cargill"
                    target="_blank"
                  >
                    <TwitterIcon
                      sx={{
                        "&:hover": {
                          color: "#007582",
                          backgroundColor: "#fff",
                        },
                        color: "#333",
                        borderRadius: "50%",
                        border: "1px solid transparent",
                        backgroundColor: "#efefef",
                        p: "6px",
                        width: 42,
                        height: 42,
                        fontSize: 42,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    title="Facebook"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/cargill"
                    target="_blank"
                  >
                    <FacebookIcon
                      sx={{
                        "&:hover": {
                          color: "#007582",
                          backgroundColor: "#fff",
                        },
                        color: "#333",
                        borderRadius: "50%",
                        border: "1px solid transparent",
                        backgroundColor: "#efefef",
                        p: "6px",
                        width: 42,
                        height: 42,
                        fontSize: 42,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    title="LinkedIn"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/cargill"
                    target="_blank"
                  >
                    <LinkedInIcon
                      sx={{
                        "&:hover": {
                          color: "#007582",
                          backgroundColor: "#fff",
                        },
                        color: "#333",
                        borderRadius: "50%",
                        border: "1px solid transparent",
                        backgroundColor: "#efefef",
                        p: "6px",
                        width: 42,
                        height: 42,
                        fontSize: 42,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    title="YouTube"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/cargill"
                    target="_blank"
                  >
                    <YouTubeIcon
                      sx={{
                        "&:hover": {
                          color: "#007582",
                          backgroundColor: "#fff",
                        },
                        color: "#333",
                        borderRadius: "50%",
                        border: "1px solid transparent",
                        backgroundColor: "#efefef",
                        p: "6px",
                        width: 42,
                        height: 42,
                        fontSize: 42,
                      }}
                    />
                  </a>
                </li>
              </Box>
            </Box>
            <Box
              sx={() => ({
                color: "#b2b2b2",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                fontSize: "1rem",
                gap: 8,
                ul: {
                  listStyle: "none",
                  fontWeight: "bold",
                  pl: { xs: 0, sm: "2rem" },
                  margin: 0,
                },
                "ul li": { margin: 0 },
                "ul.promoted": { color: "white" },
                "ul.promoted li::before": {
                  content: '"+"',
                  color: "#fcba03",
                  right: "5px",
                  position: "relative",
                  top: "-1px",
                  fontSize: "1.2em",
                },
                a: {
                  color: "inherit",
                  textDecoration: "none",
                },
              })}
            >
              <ul className="promoted">
                <li>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.cargill.com/page/cargill-contact-us"
                    target="_blank"
                  >
                    {t("common:footer.contact")}
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.cargill.com/page/worldwide"
                    target="_blank"
                  >
                    {t("common:footer.worldwide")}
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.cargill.com/page/privacy"
                    target="_blank"
                  >
                    {t("common:footer.privacy_notice")}
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    href={
                      t("common:footer.website_terms_of_use_link") ??
                      "https://www.cargill.com/portal-terms"
                    }
                    target="_blank"
                  >
                    {t("common:footer.website_terms_of_use")}
                  </a>
                </li>

                {/* [TrustArc] Manage Cookies: #teconsent */}
                <li style={{ fontSize: ".9rem" }}>
                  <span id="teconsent" className="footer-consent-link"></span>
                </li>

                {/* [TrustArc] California Residents - Do Not Sell My Personal Information: #trustarc-irm-placeholder */}
                <li style={{ fontSize: ".9rem" }}>
                  <span
                    id="trustarc-irm-placeholder"
                    className="footer-consent-link"
                  ></span>
                </li>
              </ul>
            </Box>
            <Box
              sx={{
                pt: 8,
                pl: { xs: 0, md: 8 },
                color: "rgb(178, 178, 178)",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              &copy; {new Date().getFullYear()} {t("common:footer.copyright")}
            </Box>
          </Box>
        </Footer>
      </Box>

      {/* [TrustArc] Cookie Bar: #consent_blackbar */}
      <div id="consent_blackbar" className="cookie-consent-banner"></div>
    </>
  );
}

function ThriveDecoration() {
  return (
    <Box sx={{ display: "flex", alignItems: "stretch" }}>
      <Box
        sx={(theme) => ({
          flexGrow: 1,
          // this color should work here, but the ts types don't line up
          // @ts-ignore
          backgroundColor: theme.palette.gray[90],
        })}
      ></Box>
      {/* example approach; consider externalizing decoration svgs as components */}
      <Box
        sx={{
          margin: 0,
          padding: 0,
          backgroundColor: "transparent",
          width: { xs: "116px", md: "227px" },
        }}
      >
        <svg
          style={{ display: "block" }}
          width="100%"
          height="100%"
          viewBox="0 0 227 97"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#191919"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V97H227V24.3982H124.708C109.505 24.3982 97.1759 36.7104 97.1759 51.8983V80.3108H90.078V50.6002C90.078 22.6545 67.3973 0 39.4171 0H0ZM44.1064 80.1282V65.728C44.1064 62.9296 44.5651 60.9194 45.4819 59.6973C46.3988 58.4751 47.8773 57.8641 49.9257 57.8641C51.7262 57.8641 52.9761 58.4218 53.6809 59.5378C54.3857 60.6537 54.7382 62.345 54.7382 64.6126V80.1282H62.2488V63.231C62.2488 61.5304 62.1001 59.9805 61.8027 58.5813C61.4999 57.1821 60.9823 55.9952 60.2389 55.0211C59.501 54.047 58.4879 53.2854 57.1995 52.7363C55.911 52.1872 54.2646 51.9127 52.2548 51.9127C50.8396 51.9127 49.397 52.2757 47.9158 53.002C46.434 53.7282 45.2175 54.8883 44.2649 56.4825H44.1064V42.1886H36.5951V80.1282H44.1064ZM26.6726 80.3938C27.4132 80.3938 28.1714 80.3762 28.9473 80.341C29.7231 80.3053 30.4286 80.2349 31.0629 80.1282V74.2833C30.7104 74.3543 30.3398 74.4071 29.9521 74.4428C29.564 74.478 29.1588 74.4956 28.7354 74.4956C27.4662 74.4956 26.6198 74.2833 26.1963 73.8582C25.7734 73.433 25.5619 72.5827 25.5619 71.3078V57.7046H31.0629V52.6566H25.5619V44.4204H18.0502V52.6566H13.5012V57.7046H18.0502V73.9115C18.0502 75.2931 18.2797 76.4085 18.7378 77.2588C19.1965 78.1091 19.8226 78.7647 20.6161 79.2251C21.4095 79.6854 22.3264 79.9956 23.3666 80.1551C24.4067 80.3141 25.5092 80.3938 26.6726 80.3938ZM74.9796 67.7476V80.1282H67.4689V52.6566H74.6052V57.7579H74.7153C75.0677 56.9076 75.5413 56.1195 76.1415 55.3929C76.7417 54.6669 77.4301 54.047 78.2064 53.5333C78.9828 53.0197 79.8088 52.6211 80.6898 52.3377C81.5708 52.0543 82.4904 51.9126 83.443 51.9126C83.9331 51.9126 84.4835 52.0012 85.0782 52.1783V59.1924C84.7258 59.1214 84.3074 59.0598 83.8118 59.0065C83.3162 58.9531 82.8428 58.9267 82.3857 58.9267C81.0092 58.9267 79.8419 59.1571 78.8948 59.6175C77.9421 60.0779 77.171 60.7071 76.5929 61.504C76.0093 62.301 75.5964 63.231 75.3486 64.2936C75.1008 65.3562 74.9796 66.5074 74.9796 67.7476ZM118.662 80.1282L127.918 52.6566H120.457L114.692 71.414H114.587L108.822 52.6566H100.942L110.303 80.1282H118.662ZM151.116 78.6938C148.93 80.1106 146.287 80.819 143.182 80.819C141.034 80.819 139.096 80.4736 137.367 79.7828C135.638 79.092 134.173 78.1091 132.973 76.8337C131.778 75.5588 130.853 74.0353 130.198 72.2643C129.548 70.4927 129.218 68.5446 129.218 66.4188C129.218 64.3646 129.553 62.4517 130.225 60.6801C130.897 58.9091 131.844 57.3768 133.083 56.0837C134.317 54.7909 135.786 53.7724 137.499 53.0285C139.206 52.2846 141.106 51.9126 143.182 51.9126C145.511 51.9126 147.537 52.3643 149.266 53.2676C150.995 54.1709 152.416 55.3841 153.528 56.9076C154.635 58.4306 155.439 60.1664 155.935 62.1151C156.425 64.0632 156.601 66.1004 156.463 68.2256H136.728C136.839 70.6698 137.455 72.4414 138.584 73.5392C139.713 74.6375 141.332 75.1864 143.452 75.1864C144.966 75.1864 146.271 74.8058 147.361 74.0441C148.457 73.2823 149.129 72.4766 149.371 71.6263H155.984C154.927 74.9208 153.308 77.2764 151.116 78.6938ZM148.953 63.4433H136.728C136.767 62.912 136.882 62.3098 137.075 61.6366C137.268 60.9639 137.604 60.3259 138.077 59.7237C138.556 59.1214 139.19 58.617 139.983 58.2095C140.776 57.8019 141.772 57.5984 142.973 57.5984C144.806 57.5984 146.172 58.0945 147.075 59.0862C147.972 60.0779 148.6 61.5304 148.953 63.4433ZM164.5 78C164.5 79.3807 163.381 80.5 162 80.5C160.619 80.5 159.5 79.3807 159.5 78C159.5 76.6193 160.619 75.5 162 75.5C163.381 75.5 164.5 76.6193 164.5 78ZM165 78C165 79.6569 163.657 81 162 81C160.343 81 159 79.6569 159 78C159 76.3431 160.343 75 162 75C163.657 75 165 76.3431 165 78ZM161.207 79V76.858H162.215C162.419 76.858 162.578 76.908 162.692 77.008C162.808 77.108 162.866 77.245 162.866 77.419C162.866 77.549 162.836 77.663 162.776 77.761C162.718 77.859 162.624 77.926 162.494 77.962V77.968C162.556 77.98 162.606 78 162.644 78.028C162.661 78.0394 162.675 78.0519 162.689 78.0653C162.708 78.0848 162.724 78.1063 162.737 78.13C162.761 78.168 162.778 78.211 162.788 78.259C162.8 78.307 162.809 78.357 162.815 78.409L162.819 78.4614C162.821 78.4965 162.823 78.532 162.824 78.568C162.825 78.5994 162.827 78.6306 162.831 78.6613C162.833 78.6834 162.836 78.7053 162.839 78.727C162.847 78.779 162.858 78.829 162.872 78.877C162.888 78.923 162.911 78.964 162.941 79H162.623C162.603 78.978 162.589 78.948 162.581 78.91C162.575 78.872 162.571 78.83 162.569 78.784L162.563 78.631C162.562 78.6027 162.56 78.5748 162.557 78.547C162.554 78.5218 162.55 78.4968 162.545 78.472C162.537 78.42 162.527 78.371 162.515 78.325C162.509 78.3008 162.501 78.2783 162.492 78.2576C162.482 78.2374 162.471 78.2188 162.458 78.202C162.432 78.166 162.398 78.138 162.356 78.118C162.314 78.096 162.258 78.085 162.188 78.085H161.492V79H161.207ZM161.492 77.845H162.086C162.152 77.845 162.215 77.84 162.275 77.83C162.335 77.82 162.387 77.801 162.431 77.773C162.447 77.7625 162.462 77.7508 162.476 77.7381C162.501 77.7145 162.522 77.6871 162.539 77.656C162.567 77.606 162.581 77.542 162.581 77.464C162.581 77.356 162.551 77.268 162.491 77.2C162.431 77.132 162.334 77.098 162.2 77.098H161.492V77.845Z"
          />
        </svg>
      </Box>
    </Box>
  );
}
